import { attendee } from "./attendee";
import { agendaList, momDetail} from "./basicMeetingModel";
export class SearchRequest {
  filterCol?: String;
	filterText?:String;
	pageEnd?:number=10;
	pageStart?:number=0;
	searchText?:String;
	searchType?:String;
  sort?:String="asc";
  sortColumn?:String="meetingDate";
  sortType?:String="desc";
  type?:String;
  reportedUsersId?:String;
  userId?:number;
  visitorTimezone?:String;
  meetingIdList?:any;
  startDate?:any;
  endDate?:any;
}

export interface ViewOrLinkedMeetingResponse{
  meetingId?:number;
  isConfidential?:String;
  meetingTypeDesc?:String;
  meetingDateStr?:String;
  agendaList?:agendaList[];
  attendeeList?:attendee[];
  attendeeNames?:String;
  agendaNames?:String;
  facilitator?:String;
  meetingTitle?:String;
  createdOnMilliSec?:number;
  meetingFrequency?:String;
  isMomApproved?:String;
  meetingStatusDesc?:String;
  meetingStartTime?:String;
  tzName?:String;
  momList?:momDetail[];
}
  export interface PaginationSearchResponse {
    dataList: ViewOrLinkedMeetingResponse[];
    totalCount: number;
}
